import "ekko-lightbox";

$(document).on('turbolinks:load', function() {
  $('a[data-toggle="lightbox"]').on('click', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
  });
});
